module.exports = __webpack_public_path__ + "static/media/globe.1a94bd4a.svg";